import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'WebsiteAccessForm',
  path: 'onboarding.forms.IndividualAccount.WebsiteAccessForm.inputs',
  keysToRemove: ['id'],
  content: [
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'optForAccountAccess',
            minHeight: '0',
            dataList: [
              {
                id: 'optForAccountAccess1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'optForAccountAccess2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true
          },
        },
      ]
    },
  ],
})

export default config
